var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8C14.6666 4.3181 11.6818 1.33334 7.99992 1.33334C4.31802 1.33334 1.33325 4.3181 1.33325 8C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.91667C6.75003 5.69777 6.80755 5.48271 6.91679 5.29301C7.02604 5.10331 7.18319 4.94563 7.37252 4.83574C7.56185 4.72586 7.77671 4.66761 7.99562 4.66685C8.21452 4.66608 8.42979 4.72281 8.61988 4.83137C8.80998 4.93993 8.96823 5.0965 9.0788 5.28543C9.18938 5.47435 9.2484 5.68901 9.24997 5.90791C9.25153 6.12681 9.19558 6.34228 9.08772 6.53277C8.97985 6.72326 8.82386 6.88208 8.63533 6.99334C8.31867 7.18067 8 7.46534 8 7.83334V8.66667",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99985,
    cy: 10.6667,
    r: 0.65,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqs);
export default __webpack_public_path__ + "static/media/faqs.ca61e2c2deb5e9168ed71f20534dab69.svg";
export { ForwardRef as ReactComponent };